import { useEffect, useRef, useState } from "react";
import { motion } from "framer-motion";
import { playJackpot } from "@/sound";

const COLORS = ["#F6C85F", "#E5A93C", "#B8860B", "#DC2626", "#F8FAFC"];

export default function ConfettiCannon() {
  const [pieces, setPieces] = useState([]);
  const fired = useRef(false);

  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return undefined;
    const target = document.querySelector("#roadmap");
    if (!target) return undefined;

    const observer = new IntersectionObserver(
      (entries) => {
        if (!entries[0].isIntersecting || fired.current) return;
        fired.current = true;
        const h = window.innerHeight;
        const w = window.innerWidth;
        const make = (fromLeft, i) => ({
          key: `${fromLeft ? "L" : "R"}-${i}`,
          x0: fromLeft ? -20 : w + 20,
          y0: h + 20,
          dx: (fromLeft ? 1 : -1) * (Math.random() * w * 0.55 + w * 0.12),
          up: -(Math.random() * h * 0.65 + h * 0.25),
          down: h * 1.1,
          rot: (Math.random() - 0.5) * 900,
          w: Math.random() * 6 + 5,
          h: Math.random() * 8 + 8,
          color: COLORS[Math.floor(Math.random() * COLORS.length)],
          delay: Math.random() * 0.25,
          dur: Math.random() * 0.8 + 2,
        });
        setPieces([
          ...Array.from({ length: 45 }, (_, i) => make(true, i)),
          ...Array.from({ length: 45 }, (_, i) => make(false, i)),
        ]);
        playJackpot();
        setTimeout(() => setPieces([]), 3600);
        observer.disconnect();
      },
      { threshold: 0.25 }
    );
    observer.observe(target);
    return () => observer.disconnect();
  }, []);

  return (
    <div className="pointer-events-none fixed inset-0 z-[85] overflow-hidden" aria-hidden="true" data-testid="confetti-layer">
      {pieces.map((p) => (
        <motion.span
          key={p.key}
          initial={{ x: p.x0, y: p.y0, rotate: 0, opacity: 1 }}
          animate={{
            x: p.x0 + p.dx,
            y: [p.y0, p.y0 + p.up, p.y0 + p.up + p.down],
            rotate: p.rot,
            opacity: [1, 1, 1, 0],
          }}
          transition={{
            duration: p.dur,
            delay: p.delay,
            times: [0, 0.3, 0.9, 1],
            ease: ["easeOut", "easeIn", "easeIn"],
          }}
          className="absolute rounded-[2px]"
          style={{ width: p.w, height: p.h, background: p.color }}
        />
      ))}
    </div>
  );
}
